import {useMutation} from '@github-ui/react-query'
import type {Session} from '../types/session'
import {fetchCAPI} from '../utils/fetch-capi'

interface UseStopSessionArgs {
  nwo?: string
  session?: Session
}

export function useStopSession({nwo, session}: UseStopSessionArgs) {
  return useMutation({
    mutationKey: ['stopSession', nwo, session?.id],
    mutationFn: async () => {
      const response = await fetchCAPI({
        path: `/agents/swe/jobs/${nwo}/session/${session?.id}/cancel`,
        method: 'POST',
      })
      return response
    },
  })
}
